import React from 'react';

import classNames from "classnames";
import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";
import styles from "../../styles/athlete-widget.placeholder.module.scss";
import {AthleteWidgetIconsDesktopPlaceholder} from "./icons/athlete-widget.icons-desktop.placeholder";
import {AthleteWidgetIconsMobilePlaceholder} from "./icons/athlete-widget.icons-mobile.placeholder";

export const AthleteWidgetStatsPlaceholder = ({device}) => {
  const {isSmallView} = device;

  return (
    <PlaceholderWrapperComponent className={classNames(styles.stats, {[styles.small_view]: isSmallView})}>
      <div className={classNames(styles.stats_content, {[styles.small_view]: isSmallView})}>
        <div className={classNames(styles.title)}/>
        {
          isSmallView ? <AthleteWidgetIconsMobilePlaceholder device={device}/> : <AthleteWidgetIconsDesktopPlaceholder device={device}/>
        }
      </div>
    </PlaceholderWrapperComponent>
  )
};